import { useFormatDate } from '@/shared/lib'

export const useFormatDateTime = () => {
  const { formatDate } = useFormatDate()

  const formatDateTime = (date: string | null) => {
    if (!date) return null

    return formatDate({ date: new Date(date), format: 'yyyy.MM.dd HH:mm' })
  }

  return { formatDateTime }
}
